import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk';
import createHistory from 'history/createBrowserHistory'
import rootReducer from '../reducers'

export const history = createHistory();

const INITIAL_STATE = {};
const enhancers = [];
const middleware = [
  thunk,
  routerMiddleware(history)
];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.devToolsExtension

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose (
  applyMiddleware (...middleware),
  ...enhancers
);

const store = createStore(
  rootReducer,
  INITIAL_STATE,
  composedEnhancers
);

export default store;


// WEBPACK FOOTER //
// ./src/store/store.js